const queryKeys = {
  all: () => ['unknown'] as const,

  getBuyerEstimateInput: () => ['estimate-buyer-input'] as const,
  getInvestorEstimateInput: () => ['estimate-investor-input'] as const,
};

export default queryKeys;